import { call, put } from 'redux-saga/effects';
import AuthorizationApi from '../api/AuthorizationApi';
import userDataReceived from '../actions/userDataReceived';
import getUserDataFailed from '../actions/getUserDataFailed';

export default function* getCurrentUserSaga() {
    try {
        const response = yield call(AuthorizationApi.GetCurrentUser);
        yield put(userDataReceived(response.data));
    } catch (error) {
        yield put(getUserDataFailed(error));
    }
}
